export default "__VITE_ASSET__D7Dega2U__"